import type { ComponentType } from 'react'

export function isThemeComponent(value: unknown): value is ComponentType {
  if (typeof value === 'function') return true
  if (typeof value !== 'object' || value === null || !('$$typeof' in value)) return false
  return [Symbol.for('react.memo'), Symbol.for('react.forward_ref'), Symbol.for('react.lazy')].includes(value.$$typeof as symbol)
}
